module.exports = __webpack_public_path__ + "img/case1.ee027390.svg";